import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import classes from './TextLink.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo } from '@fortawesome/free-solid-svg-icons';

export const TextLink = (props) => (
    <span className={classes.TextLink} >
        <Link to={props.link}> {props.text} </Link>
    </span>
);

export const BackTextLink = (props) => (
    <div className={classes.TextLink} >
        <a  href=''
            onClick = {
                e => {
                    e.preventDefault();
                    window.history.go(-1);
                }
            }
        >
        <FontAwesomeIcon icon={faUndo}/> Go Back 
        </a>
    </div>
);

export const ButtonLink = (props) => (
    <span className={classes.ButtonLink}>
    <Link to={props.link}> 
        <Button size={ (props.size) ? props.size : 'sm'} block variant="outline-info">
            {props.text}
            {(props.icon) ? <span> &nbsp;<FontAwesomeIcon icon={props.icon} /></span> : null}
        </Button> 
    </Link>
    </span>
)

export const TextButton = (props) => (
    <span className={classes.TextButton} onClick={props.callback}>
        { props.text }
    </span>
);

export default TextLink;


// WEBPACK FOOTER //
// ./src/components/UI/TextLink/TextLink.js